module.exports = __webpack_public_path__ + "img/DSC_0100.9fb5bba2.jpeg";